import { appName, appVersion, updateTime } from "../../version.json";
const logText = `%c${appName}\n当前版本: ${appVersion}\n更新时间: ${updateTime}`;
console.log(logText, "color: #409eff;font-size: 14px");


